import { api } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPushPermission() {
  if (!await isPushSupported()) return 'unsupported';
  return Notification.permission;
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw-push.js');
    return reg;
  } catch (err) {
    console.error('SW registration failed:', err);
    return null;
  }
}

export async function subscribeToPush() {
  if (!await isPushSupported()) {
    throw new Error('Push notifications no soportadas en este navegador');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Permiso de notificaciones denegado');
  }

  const reg = await registerServiceWorker();
  if (!reg) throw new Error('No se pudo registrar el Service Worker');

  // Get VAPID key from backend
  const { public_key } = await api.get('/api/notifications/vapid-public-key');
  if (!public_key) throw new Error('Clave VAPID no configurada en el servidor');

  const applicationServerKey = urlBase64ToUint8Array(public_key);

  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });

  const subJson = subscription.toJSON();

  // Register subscription on backend
  await api.post('/api/notifications/subscribe', {
    endpoint: subJson.endpoint,
    keys: subJson.keys,
  });

  return subscription;
}

export async function unsubscribeFromPush() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return;

  const subscription = await reg.pushManager.getSubscription();
  if (!subscription) return;

  const subJson = subscription.toJSON();

  await subscription.unsubscribe();

  try {
    await api.post('/api/notifications/unsubscribe', {
      endpoint: subJson.endpoint,
      keys: subJson.keys,
    });
  } catch (err) {
    console.warn('Backend unsubscribe failed:', err);
  }
}

export async function isCurrentlySubscribed() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return false;
  const sub = await reg.pushManager.getSubscription();
  return !!sub;
}
